export const GlobalApplicationName = '- Ikke henført til applikasjon -';
